export default "https://cdn-static.gokick.com/assets/38a17193d7f2ad0638d84ec7199a8f76eb0c19ef/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";